import React from "react";
import { DataGridHeader, DataGridHeading } from "@conserveit/blocks";
import { I18n } from "@lingui/core";
import { actionColumns, Direction } from "../../../../utils/columns";
import SortArrow from "../../../SortArrow";

interface Props {
  sortFilter: string;
  sortDirection: Direction;
  i18n: I18n;
  handleClickHeader: (key: string) => () => void;
}
const ListHeader: React.FC<Props> = (props) => {
  const { sortFilter, sortDirection, i18n, handleClickHeader } = props;

  return (
    <DataGridHeader cursor="pointer">
      <DataGridHeading onClick={handleClickHeader(actionColumns.ID.key)}>
        {actionColumns.ID.label(i18n)}
        {sortFilter === actionColumns.ID.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading onClick={handleClickHeader(actionColumns.PRIORITY.key)}>
        {actionColumns.PRIORITY.label(i18n)}
        {sortFilter === actionColumns.PRIORITY.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.SITE.width}
        onClick={handleClickHeader(actionColumns.SITE.key)}
      >
        {actionColumns.SITE.label(i18n)}
        {sortFilter === actionColumns.SITE.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.SUMMARY.width}
        onClick={handleClickHeader(actionColumns.SUMMARY.key)}
      >
        {actionColumns.SUMMARY.label(i18n)}
        {sortFilter === actionColumns.SUMMARY.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.CONTEXT.width}
        onClick={handleClickHeader(actionColumns.CONTEXT.key)}
      >
        {actionColumns.CONTEXT.label(i18n)}
        {sortFilter === actionColumns.CONTEXT.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.RESPONSIBLE.width}
        onClick={handleClickHeader(actionColumns.RESPONSIBLE.key)}
      >
        {actionColumns.RESPONSIBLE.label(i18n)}
        {sortFilter === actionColumns.RESPONSIBLE.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.DATES.width}
        onClick={handleClickHeader(actionColumns.DATES.key)}
      >
        {actionColumns.DATES.label(i18n)}
        {sortFilter === actionColumns.DATES.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>

      <DataGridHeading
        // minWidth={actionColumns.STATUS.width}
        onClick={handleClickHeader(actionColumns.STATUS.key)}
      >
        {actionColumns.STATUS.label(i18n)}
        {sortFilter === actionColumns.STATUS.key && (
          <SortArrow direction={sortDirection} />
        )}
      </DataGridHeading>
    </DataGridHeader>
  );
};

export default ListHeader;
